import React from 'react'
import LandingWrapper from './LandingWrapper'
import { BsCheckCircleFill } from 'react-icons/bs'
import './styles.css'

export default function LandingToken() {
    return (
        <LandingWrapper>
            <Header />
            <DescToken />
            <TokenImage />
            <TokenBanner />
            <HowItsWork />
            <TokenBenefits />
        </LandingWrapper>
    )
}

const Header = () => {
    return (
        <React.Fragment>
            <div className="landing-token__body-content">
                <div className='flip-header-token'>
                    <div className="landing-token__body-content-left-title">
                        <h1>Basé sur une technologie de PKI, le Token permet d'authentifiez vos signatures</h1>
                    </div>
                    <a className="landing_api-weclient-contactus">DEMANDER UNE DEMO</a>
                </div>

            </div>

        </React.Fragment>
    )
}

const DescToken = () => {
    return (
        <div className="landing-token__desc-content">
            <div className="landing-token__desc-item">
                <p>Le Token de DKBSign</p>
                <p>
                    Le token PKI de DKBSign offre un stockage sécurisé pour les certificats numériques et les clés privées. Il permet d'utiliser la cryptographie à clé publique et les signatures numériques de façon parfaitement sécurisée, sans risque de fuite des clés privées.
                    Le token ou certificat personne physique est l'équivalent d'une véritable carte d'identité numérique professionnelle certifiée par le tiers de confiance DKBSign. C’est un certificat hébergé sur un ordinateur ou un support physique (carte à puce, clé USB, token) lié à une personne physique (et éventuellement lié aussi à son entreprise, à sa banque, à son ISP). Notre certificat de personne physique permet une authentification forte et la signature électronique des documents.
                    <br />
                    <br />
                    Le token est idéale pour les petites et moyennes entreprises souhaitant rester en conformité avec les réglementations et s'adapter aux besoins des télétravailleurs ou employés en déplacement.
                    <p className='hyphen'><BsCheckCircleFill className='hyphen-check' /> Signatures à l’aide d’identités individuelles ou au niveau de l'entreprise ou du département</p>
                    <p className='hyphen'><BsCheckCircleFill className='hyphen-check' /> Respect des exigences réglementaires nationales et sectorielles applicables aux signatures numériques</p>
                    <p className='hyphen'><BsCheckCircleFill className='hyphen-check' /> Protection de la propriété intellectuelle grâce à la garantie d’intégrité et d’authenticité des documents</p>
                    <p className='hyphen'><BsCheckCircleFill className='hyphen-check' /> Ajout de signatures d’approbation personnalisables (image de signature physique ou cachet/sceau de la profession)</p>
                    <p className='hyphen'><BsCheckCircleFill className='hyphen-check' /> Signature de plusieurs types de documents avec un seul identifiant</p>
                    <p className='hyphen'><BsCheckCircleFill className='hyphen-check' /> Horodatage inclus qui prend en charge les scénarios avec pistes d’audit et permet le respect des règles de conformité</p>
                </p>
            </div>
            <img src="./assets/media/home_icon/key_img.png" alt="key_img" className='key_img' />
        </div>
    )
}

const TokenImage = () => {
    return (
        <div className="landing-token__image-content">
            <img src="./assets/media/home_icon/token2.png" alt="key_img" className='landing-token__image-content-img' />
        </div>
    )
}

const TokenBanner = () => {
    return (
        <div className="landing-token__image-content-banner">
            <div className="landing-token__howitswork-title">Le Token permet de :</div>
            <div className="landing-token__image-content-img-banner">
                <img src="./assets/media/home_icon/_token1_permit.png" alt="key_img" className='landing-token__image-content-img-banner-items' />
                <img src="./assets/media/home_icon/_token2_permit.png" alt="key_img" className='landing-token__image-content-img-banner-items' />
                <img src="./assets/media/home_icon/_token3_permit.png" alt="key_img" className='landing-token__image-content-img-banner-items' />
                <img src="./assets/media/home_icon/_token4_permit.png" alt="key_img" className='landing-token__image-content-img-banner-items' />
                <img src="./assets/media/home_icon/_token5_permit.png" alt="key_img" className='landing-token__image-content-img-banner-items' />
            </div>
        </div>
    )
}

const HowItsWork = () => {
    return (
        <div className="landing-token__howitswork-content">
            <div style={{ color: 'white' }} className="landing-token__howitswork-adobeTxt">Signatures pour vos documents Adobe PDF et MS office disponibles</div>
            <div className="landing-token__desc-content-howtswork">
                <div className="landing-token__desc-item-howtswork">
                    <p style={{ color: 'white' }}>
                        Signatures pour vos documents Adobe PDF et MS office disponibles
                        pour toute l’entreprise

                        Ajoutez facilement un gage de confiance et d’intégrité à vos documents et communications d'entreprise grâce aux signatures numériques DKBSign pour Microsoft Word, Microsoft Excel, Microsoft PowerPoint et Microsoft Outlook.

                        <p className='hyphen'><BsCheckCircleFill className='hyphen-check' /> Permet des échanges de documents électroniques sécurisés</p>
                        <p className='hyphen'><BsCheckCircleFill className='hyphen-check' /> Garantit l'origine et l'intégrité du document</p>
                        <p className='hyphen'><BsCheckCircleFill className='hyphen-check' /> Permet d'économiser du temps et de l'argent grâce à la dématérialisation de vos documents papiers</p>
                        <p className='hyphen'><BsCheckCircleFill className='hyphen-check' /> Est conforme aux réglementations en vigueur sur les documents électroniques</p>
                        <p className='hyphen'><BsCheckCircleFill className='hyphen-check' /> Permet de signer également vos documents PDFs</p>
                    </p>
                </div>
                <img src="./assets/media/home_icon/token24.png" alt="key_img" className='key_img-howtswork' />
            </div>
        </div>
    )
}

const TokenBenefits = () => {
    return (
        <div className="landing-token__benefits">
            <div className="landing-token__benefits-title">Notre Token est</div>
            <div className="landing-token__benefits-list">
                <Benefits image="./assets/media/home_icon/_token1.png" desc="Facile D'usage" />
                <Benefits image="./assets/media/home_icon/_token_2.png" desc="A faible côut" />
                <Benefits image="./assets/media/home_icon/_token_3.png" desc="Fiable et sécurisé" />
            </div>
            <a style={{ marginTop: '15px' }} className="landing_api-weclient-contactus">DEMANDER UNE DEMO</a>
        </div>
    )
}



const Benefits = ({ image, desc }) => {
    return (
        <div className="landing-token__benefits-content">
            <img src={image} alt="key_img" className='landing-token__benefits-content-no' />
            <div className="landing-token__benefits-content-desc">{desc}</div>
        </div>
    )
}